export default __webpack_public_path__ + "static/media/righello.6621de20.png";